import {
  isEmpty,
  last,
} from 'lodash';
import VisualUpload from './VisualUpload';
import './MediaItems.scss';

function MediaItems({
  visualFiles,
  onUpdateVisualFiles,
  onUpdate,
  resolutions,
  messageStatus,
  resolutionErrors,
}) {
  return (
    <div className="MediaItems">
      {resolutionErrors && (
        <div className="resolution-error">Location details have changed.
          Some of the items you attempted to upload no longer match a selected location resolution
        </div>
      )}
      {resolutions.length > 0 ? resolutions.map((resolution, i) => {
        const visualItem = visualFiles.filter(visualfile => (resolution.size[0] === visualfile.targetDisplay.size[0]
          && resolution.size[1] === visualfile.targetDisplay.size[1]));

        return (
          <div className="media-item" key={i}>
            <div className="media-item-resolution">
              {resolution.name}
              {/* <span className="field-dot" /> */}
            </div>
            <div className="media-item-drop">
              <VisualUpload
                file={!isEmpty(visualItem) ? last(visualItem) : {}}
                onUpdateVisualFiles={onUpdateVisualFiles}
                targetDisplay={resolution}
                messageStatus={messageStatus}
                fileIndex={i}
                onUpdate={onUpdate}
              />
            </div>
          </div>
        );
      }) : <div className="empty-media-items">Select locations before adding media items.</div>}
    </div>
  );
}

export default MediaItems;
